(function($){
	document.addEventListener('DOMContentLoaded', ()=> {
		function __renaissanceBankUpdate() {
			const singleDataId = $('.product-card__btn-panel').attr('data-id');
			const isInBasket = $('.product-card__btn-panel').hasClass('product-card__btn-panel--in-basket');

			$('.js-renaissance-form-spoiler').each((index, item)=> {
				if (!window.rw || !window.rw.basket) return;
				let basketItems = window.rw.basket; //shortcut

				const singleItem = window.rw.basket.find((i)=> i.product_id === singleDataId);
				if (singleDataId && isInBasket) basketItems = singleItem ? [singleItem] : [];
				if (singleDataId && !isInBasket) return;

				const $price = $(item).find('.form-spoiler__header-price');
				if ($price.length) {
					const finalPrice = basketItems.reduce((acc, item)=>{
						return acc + (parseFloat(item.price_credit) * parseInt(item.quantity));
					}, 0);
					$price.text(`${finalPrice.toFixed(2)} ₽`);
				}

				const $row = $(item).find('.form-spoiler__inner-row');
				if ($row.length) {
					$row.html('');

					basketItems.length && basketItems.forEach((basketItem)=> {
						const row = document.createElement('li');
						$(row).addClass('form-spoiler__inner-item');
						$(row).append(`<span class="form-spoiler__inner-item-name">${basketItem.name}</span>`);
						$(row).append(`
							<span class="form-spoiler__inner-item-price">
								${(basketItem.quantity * basketItem.price_credit).toFixed(2)} ₽
							</span>`);
						$($row).append(row);
					});
				} else {
					console.warn('BasketUpdate: Renaissance form spoiler can`t find inner row element');
				}
			});
		}

		function __checkIsItemInBasketAndRunRenaissanceUpdate() {
			const $ptnBanel = $('.product-card__btn-panel');
			if (!$ptnBanel.length) return;
			$ptnBanel.hasClass('product-card__btn-panel--in-basket') && __renaissanceBankUpdate();
		}

		__checkIsItemInBasketAndRunRenaissanceUpdate();
		document.addEventListener('basket:update', __renaissanceBankUpdate);
	});
// eslint-disable-next-line no-undef
})(jQuery);
